var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHollyday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M716 190.9v-67.8h-44v67.8H352v-67.8h-44v67.8H92v710h840v-710H716z m-580 44h172v69.2h44v-69.2h320v69.2h44v-69.2h172v151.3H136V234.9z m752 622H136V402.2h752v454.7z",
    fill: "#39393A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319 565.7m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M510 565.7m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M701.1 565.7m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319 693.4m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510 693.4m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M701.1 693.4m-33 0a33 33 0 1 0 66 0 33 33 0 1 0-66 0Z",
    fill: "#E73B37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollyday);
export default __webpack_public_path__ + "static/media/hollyday.3dc60cfad67cc48d0404a35476103b38.svg";
export { ForwardRef as ReactComponent };